import { evaluateConditionExpression } from "./expression";
import { IF_OPEN_TOKEN_START, createBlockTokenRegex, isElseContent, readTokenContent, } from "./tokens";
function parseTemplate(template) {
    const root = [];
    const open = [];
    const pattern = createBlockTokenRegex();
    const current = () => {
        const block = open[open.length - 1];
        if (!block)
            return root;
        return block.branch === "then" ? block.node.then : block.node.otherwise;
    };
    const pushText = (value) => {
        if (value)
            current().push({ type: "text", value });
    };
    let lastIndex = 0;
    let match;
    while ((match = pattern.exec(template)) !== null) {
        pushText(template.slice(lastIndex, match.index));
        lastIndex = match.index + match[0].length;
        const [raw, ifExpression] = match;
        if (ifExpression) {
            const node = {
                type: "if",
                expression: ifExpression.trim(),
                then: [],
                otherwise: [],
            };
            current().push(node);
            open.push({ node, branch: "then" });
            continue;
        }
        const block = open[open.length - 1];
        if (!block)
            continue;
        if (isElseContent(readTokenContent(raw))) {
            block.branch = "otherwise";
            continue;
        }
        open.pop();
    }
    pushText(template.slice(lastIndex));
    return root;
}
function renderNodes({ nodes, resolve, }) {
    return nodes
        .map((node) => {
        if (node.type === "text")
            return node.value;
        const branch = evaluateConditionExpression({ expression: node.expression, resolve })
            ? node.then
            : node.otherwise;
        return renderNodes({ nodes: branch, resolve });
    })
        .join("");
}
export function resolveConditionals({ template, resolve, }) {
    if (!template.includes(IF_OPEN_TOKEN_START))
        return template;
    return renderNodes({ nodes: parseTemplate(template), resolve });
}
